import { Button, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, List, ListItem, ListItemIcon, ListItemText, MenuItem, Paper, Select, Tab, Tabs, Theme, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import MyTable, { TableRow } from "../../../components/MyTable";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { TableHeadRows } from "../../../components/MyTable/TableHead";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { searchApprovalGroupsCompanies, searchApprovalGroupsEmployees, searchApprovalGroupsResponsables } from "../../../store/slices/userRequests";
import { changeApprovalResponsableRole, deleteApprovalGroups, deleteEmployees, deleteResponsables, getApprovalGroups } from "../../../api/s10OrganizationApi";
import { ApprovalGroups, AuthResponse, ModifyApprovalGroup } from "../../../interfaces/auth.interface";
import EditIcon from '@mui/icons-material/Edit';
import MySnackbar from "../../../components/MySnackbar";
import CreateApprovalGroupModal from "./ApprovalGroups";
import EmployeesModal from "./EmployeesModal";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

const tabOptions = [{
    label: "Grupos",
},{
    label: "Responsables",
},{
    label: "Colaboradores",
},
]

const ApprovalEmployeeCard = (row: any) => {
    return (
        <CardContent style={{padding: "0 1rem 1rem 55px"}}>
            <Typography variant="body2" color="text.primary" marginBottom=".5rem">
                {row.EMail} 
            </Typography>
        </CardContent>
    )
}

const ApprovalResponsableCard = (row: any, onChangeRole?: (row: any) => void) => {
    const isEligible = row.RoleId === 3 || row.RoleId === 6;
    const targetRole = row.RoleId === 3 ? "Aprobador" : "Colaborador";
    
    return (
        <CardContent style={{padding: "0 1rem 1rem 55px"}}>
            <Typography variant="body2" color="text.primary" marginBottom=".5rem">
                {row.RoleName} 
            </Typography>
            <Typography variant="body2" color="text.primary" marginBottom=".5rem">
                {row.EMail} 
            </Typography>
            {isEligible && (
                <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    startIcon={<SwapHorizIcon />}
                    onClick={(e) => {
                        e.stopPropagation();
                        onChangeRole && onChangeRole(row);
                    }}
                    style={{ marginTop: '0.5rem' }}
                >
                    Cambiar a {targetRole}
                </Button>
            )}
        </CardContent>
    );
};

const ApprovalGroupCard = (
    row: any, 
    theme: Theme,
    setApprovalGroupoEdit: (value: ModifyApprovalGroup | undefined) => void,
    setOpenApprovalGroupsModal: (value: boolean) => void,
) => {
    // const theme = useTheme();
    return (
        <CardContent style={{padding: "0  1rem 1rem 1rem"}}>
            <Typography
                gutterBottom
                variant="h6"
                component="div"
                sx={{
                    minHeight: '2.8em',
                    maxHeight: "3.8em",
                    overflow: 'hidden',
                    color: theme.s10palette.S10Blueblue700,
                    alignContent: "center"
                }}
                fontSize=".8em"
            >
                {row.Id} - {row.Name} 
            </Typography>
            <Grid>  
                <Typography variant="subtitle2" color="text.primary" marginBottom=".5rem" display="inline">
                    Grupo de notificación:{" "}
                </Typography>
                <Typography variant="body2" color="text.primary" marginBottom=".5rem" display="inline">
                    {row.NotificationGroupName} 
                </Typography>
            </Grid>
            <Grid>
                <Typography variant="subtitle2" color="text.primary" marginBottom=".5rem" display="inline">
                    N. Aprob:{" "}
                </Typography>
                <Typography variant="body2" color="text.primary" marginBottom=".5rem" display="inline">
                    {row.ApproversNumber} 
                </Typography>
            </Grid>
            <Grid>
                <Typography variant="subtitle2" color="text.primary" marginBottom=".5rem" display="inline">
                    Área:{" "}
                </Typography>
                <Typography variant="body2" color="text.primary" marginBottom=".5rem" display="inline">
                    {row.OfficeName} 
                </Typography>
            </Grid>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                        e.stopPropagation();
                        console.log("###")
                        console.log(e)
                        setApprovalGroupoEdit(row as any);
                        setOpenApprovalGroupsModal(true)
                    }}
                    disableElevation
                    style={{
                        minWidth: "2rem",
                        minHeight: "2rem",
                        padding: ".25rem"
                    }}
                >
                    <EditIcon />
                </Button>
        </CardContent>
    )
}

// label: "N. Aprob",
// rowKeyName: "ApproversNumber",
// label: "Grupo de notificación",
// rowKeyName: "NotificationGroupName",
// label: "Área",
// rowKeyName: "OfficeName",

const ApprovalGroupsView = () => {

    const theme = useTheme();
    const dispatch = useDispatch<AppDispatch>();
    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const {companies, companiesIsLoading, responsables, responsablesLoading, employees} = useSelector((state: RootState) => state.userRequests).approvalGroups;
    const [tabOptionSelected, setTabOptionSelected] = useState(0);
    
    const [timeToResetSelectedItems, setTimeToResetSelectedItems] = useState<string>("");
    const [selectedItems, setSelectedItems] = useState<any[]>([]);
    const [selectorFieldName, setSelectorFieldName] = useState<string>("");
    const [selectedCompany, setSelectedCompany] = useState<string>("");
    const [selectedApprovalGroup, setSelectedApprovalGroup] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);


    const [approvalGroups, setApprovalGroups] = useState<ApprovalGroups[]>([]);
    const [openApprovalGroupsModal, setOpenApprovalGroupsModal] = useState<boolean>(false);
    const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
    const [selectedItemsLabel, setSelectedItemsLabel] = useState<string[]>([]);
    const [openEmployeesModal, setOpenEmployeesModal] = useState<boolean>(false);
    const [approvalGroupoEdit, setApprovalGroupoEdit] = useState<ModifyApprovalGroup | undefined>();
    const [snackBarMessage, setSnackBarMessage] = useState<any | undefined>();


    const [openChangeRoleModal, setOpenChangeRoleModal] = useState<boolean>(false);
    const [selectedResponsible, setSelectedResponsible] = useState<any | null>(null);
    const [newRoleId, setNewRoleId] = useState<number | null>(null);
    const [changingRole, setChangingRole] = useState<boolean>(false);

    const groupHeader = [{
        label: "Id",
        rowKeyName: "Id",
    },{
        label: "Grupo",
        rowKeyName: "Name",
    },{
        label: "N. Aprob",
        rowKeyName: "ApproversNumber",
    },{
        label: "Grupo de notificación",
        rowKeyName: "NotificationGroupName",
    },{
        label: "Área",
        rowKeyName: "OfficeName",
    },{
        label: "Responsables",
        rowKeyName: "ResponsableCount",
    },{
        label: "Colaboradores",
        rowKeyName: "EmployeeCount",
    },{
        label: "",
        rowKeyName: "actions",
        customValue: (headRow: TableHeadRows, row: TableRow<string, any>) => {
            return (
                <Button
                    variant="contained"
                    color="inherit"
                    onClick={() => {
                        setApprovalGroupoEdit(row as any);
                        setOpenApprovalGroupsModal(true)
                    }}
                    disableElevation
                    style={{
                        minWidth: "2rem",
                        minHeight: "2rem",
                        padding: ".25rem"
                    }}
                >
                    <EditIcon />
                </Button>
            )
        },
    }]
    const responsibleHeader = [{
            label: "Responsable",
            rowKeyName: "Descripcion",
        },{
            label: "Correo electrónico",
            rowKeyName: "EMail",
        },{
            label: "DNI",
            rowKeyName: "DNI",
        },{
            label: "Rol",
            rowKeyName: "RoleName",
        },
        {
            label: "Acciones",
            rowKeyName: "actions",
            customValue: (headRow: TableHeadRows, row: TableRow<string, any>) => {
                const roleId = row.RoleId;
                if (roleId !== 3 && roleId !== 6) return null;
                const targetRole = roleId === 3 ? "Aprobador" : "Colaborador";
                return (
                    <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        startIcon={<SwapHorizIcon />}
                        onClick={() => handleOpenChangeRoleModal(row)}
                        style={{
                            padding: "2px 6px",
                            fontSize: "0.7rem",
                            minWidth: "unset",
                            lineHeight: "1.2",
                        }}
                    >
                        Cambiar a {targetRole}
                    </Button>
                );
            },
        },
    ]
    const employeeHeader = [{
        label: "Colaboradores",
        rowKeyName: "Descripcion",
    },{
        label: "Correo electrónico",
        rowKeyName: "EMail",
    },]

    const handleOpenChangeRoleModal = (row: any) => {
        const newRole = row.RoleId === 3 ? 6 : 3;
        setSelectedResponsible(row);
        setNewRoleId(newRole);
        setOpenChangeRoleModal(true);
    };

    const handleCloseChangeRoleModal = () => {
        setOpenChangeRoleModal(false);
        setSelectedResponsible(null);
        setNewRoleId(null);
    };
    const handleConfirmChangeRole = async () => {
        if (!selectedResponsible || newRoleId === null) return;
        setChangingRole(true);
        const response = await changeApprovalResponsableRole({
            SecurityUserId: selectedResponsible.SecurityUserId, // o Id según tu API
            IsApprovalActive: newRoleId === 6 ? 1 : 0,
        });
        console.log(response)
        if (response.data?.Type === 0) {
            setSnackBarMessage({
                success: true,
                msg: `Rol cambiado a ${newRoleId === 3 ? 'Colaborador' : 'Aprobador'} correctamente.`
            });
            dispatch(searchApprovalGroupsResponsables(selectedApprovalGroup));
            handleCloseChangeRoleModal();
        } else {
            setSnackBarMessage({
                success: false,
                msg: response.data?.Message || "Ocurrió un error al cambiar el rol."
            });
        }
        setChangingRole(false);
    };

    const handleCloseModal = ({success, msg}: {success?: boolean, msg?: string}) => {
        setApprovalGroupoEdit(undefined);
        setOpenApprovalGroupsModal(false);
        setOpenEmployeesModal(false)
        if (success) {
            switch (tabOptionSelected) {
                case 0:
                    getApprovalGroups(selectedCompany)
                        .then(response => {
                            setApprovalGroups(response.data);
                        });
                    break;
                case 1:
                    dispatch(searchApprovalGroupsResponsables(selectedApprovalGroup));
                    break;
                case 2:
                    dispatch(searchApprovalGroupsEmployees(selectedApprovalGroup));
                    break;

            }
            setSnackBarMessage({success, msg})
        } else if (msg) {
            setSnackBarMessage({success, msg})
        }
    }

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabOptionSelected(newValue);
    };

    const handleAddAction = () => {
        switch (tabOptionSelected) {
            case 0:
                setOpenApprovalGroupsModal(true)
                break;
            case 1:
                setOpenEmployeesModal(true)
                break
            case 2:
                setOpenEmployeesModal(true)
                break
        }
    }

    const handleDeleteApprovalGroups = async (): Promise<boolean> => {
        const ids = selectedItems.map(r => r.value || r);
        const result =  await deleteApprovalGroups({ids})
            .then(({data}) => {
                if (data?.Type === 0) {
                    setSnackBarMessage({success: true, msg: "Grupos eliminados con éxito."})
                    getApprovalGroups(selectedCompany)
                        .then(response => {
                            setApprovalGroups(response.data);
                        });
                    return true;
                } else {
                    console.log(data);
                    setSnackBarMessage({success: false, msg: "Ocurrio un error eliminando grupos"})
                    return false;
                }
            })
        return result;
    }

    const handleDeleteResponsables = () => {
        const ids = selectedItems.map(r => r?.value || r);
        return deleteResponsables({ids})
            .then(({data}: {data: AuthResponse}) => {
                if (data?.Type === 0) {
                    setSnackBarMessage({success: true, msg: "Responsables eliminados con éxito."})
                    dispatch(searchApprovalGroupsResponsables(selectedApprovalGroup));
                    return true;
                } else {
                    console.log(data);
                    setSnackBarMessage({success: false, msg: "Ocurrio un error eliminando responsables"})
                    return false;
                }
            })
    }

    const handleResetSelectedItems = () => {
        setTimeToResetSelectedItems(new Date().toISOString())
        setSelectedItems([])
        setLoading(true)
        setLoading(false)
    }

    const handleDeleteEmployees = () => {
        const ids = selectedItems.map(r => r?.value || r);
        return deleteEmployees({ids})
            .then(({data}: {data: AuthResponse}) => {
                if (data?.Type === 0) {
                    handleResetSelectedItems();
                    setSnackBarMessage({success: true, msg: "Colaboradores eliminados con éxito."})
                    dispatch(searchApprovalGroupsEmployees(selectedApprovalGroup));
                    return true;
                } else {
                    console.log(data);
                    setSnackBarMessage({success: false, msg: "Ocurrio un error eliminando colaboradores"})
                    return false;
                }
            })
    }

    const handleDeleteAction = async (): Promise<boolean> => {
        switch (tabOptionSelected) {
            case 0:
                return await handleDeleteApprovalGroups();
            case 1:
                return await handleDeleteResponsables();
            case 2:
                return await handleDeleteEmployees();
            default:
                return false
        }
    }

    useEffect(() => {
        if (!companies.length || selectedCompany) {
            return;
        }
        const currentCompany = companies.find(c => c?.RUC as any === companyselected?.RUC)
        setSelectedCompany(currentCompany? currentCompany.RUC : companies[0].RUC);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companies])

    useEffect(() => {
        if (!connectionId || !companyselected?.Token || companiesIsLoading) {
            return;
        }
        dispatch(searchApprovalGroupsCompanies());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected?.Token, connectionId])


    useEffect(() => {
        if (!selectedCompany) {
            return;
        }
        handleResetSelectedItems();
        setSelectorFieldName("");
        
        switch (tabOptionSelected) {
            case 0:
                setSelectorFieldName("Id");
                setLoading(true);
                getApprovalGroups(selectedCompany)
                    .then(response => {
                        setApprovalGroups(response.data);
                        if (response.data.length) {
                            setSelectedApprovalGroup(response.data[0].Id)
                        }
                    })
                    .finally(() => {
                        setLoading(false)
                    });
                break;
            case 1:
                setSelectorFieldName("responsableId");
                dispatch(searchApprovalGroupsResponsables(selectedApprovalGroup));
                break;
            case 2:
                setSelectorFieldName("Id");
                dispatch(searchApprovalGroupsEmployees(selectedApprovalGroup));
                break;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabOptionSelected, selectedApprovalGroup]);

    const handleDeleteItems = async () => {
        console.log(selectedItems)
        const data = tabOptionSelected === 0
                        ? approvalGroups
                        : tabOptionSelected === 1
                            ? responsables
                            : employees;
        const selectedItemsData = (data as any)
                            .filter((d: any) => selectedItems.includes(d[selectorFieldName]))
                            .map((m: any) => tabOptionSelected === 0
                                                ? `Grupo ${m.Name}. Colaboradores: ${m.EmployeeCount}, Responsables: ${m.ResponsableCount}`
                                                : m.Descripcion)
        setSelectedItemsLabel(selectedItemsData);
        setOpenDeleteModal(true);
    }

    return (
        <Grid item width="100%" marginTop="1.5rem" minHeight="60%">
            <Paper 
                elevation={3}
                style={{
                    width: "100%", 
                    borderRadius: "0.5rem",
                    minHeight: "10rem",
                    padding: "2rem 1.5rem"
                }}
            >
                <Grid container spacing={2} marginBottom="1.5rem">
                    {companies.length > 0 && <Grid item>
                        <FormControl style={{minWidth: "15rem"}}>
                            <InputLabel id="select-option-label">Empresa</InputLabel>
                            <Select
                                labelId="select-option-label"
                                id="select-option"
                                label={"Empresa"}
                                onChange={(event: { target: { value: string } }) => {
                                    const value = event.target.value;
                                    setTabOptionSelected(0)
                                    setSelectedCompany(value);
                                }}
                                value={selectedCompany}
                                style={{height: "2.5rem", border: "none", backgroundColor: "white"}}
                            >
                                {companies?.map((item, i) => (
                                    <MenuItem
                                        key={i} 
                                        value={item.RUC}
                                    >
                                        {item.Descripcion}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>}
                    {[1, 2,].includes(tabOptionSelected) && approvalGroups.length > 0 && <Grid item>
                        <FormControl style={{minWidth: "15rem"}}>
                            <InputLabel id="select-option-label">Grupo de aprobación</InputLabel>
                            <Select
                                labelId="select-option-label"
                                id="select-option"
                                label={"Grupo de aprobación"}
                                onChange={(event: { target: { value: string } }) => {
                                    const value = event.target.value;
                                    setSelectedApprovalGroup(value);
                                }}
                                value={selectedApprovalGroup}
                                style={{height: "2.5rem", border: "none", backgroundColor: "white"}}
                            >
                                {approvalGroups?.map((item, i) => (
                                    <MenuItem
                                        key={i} 
                                        value={item.Id}
                                    >
                                        {item.Name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>}
                </Grid>
                <Grid sx={{ borderBottom: 1, borderColor: '#E8E8E8' }}>
                    <Tabs value={tabOptionSelected} onChange={handleChange} aria-label="basic tabs example">
                        {tabOptions.map((t, i) => (
                            <Tab key={i} label={t.label} style={{
                                color: i === tabOptionSelected 
                                    ? `${theme.s10palette.S10Blueblue600}` 
                                    : `${theme.s10palette.S10Greygrey300}`,
                                fontFamily: 'Roboto',
                                fontSize: '1rem',
                                fontStyle: 'normal',
                                fontWeight: '700',
                                lineHeight: 'normal',
                            }} />
                        ))}
                    </Tabs>
                </Grid>
                <MyTable
                    key={`tab-${tabOptionSelected}`}
                    tableHeadRows={
                        tabOptionSelected === 0
                            ? groupHeader
                            : tabOptionSelected === 1
                                ? responsibleHeader
                                : employeeHeader
                    }
                    tableRows={
                        tabOptionSelected === 0
                            ? approvalGroups
                            : tabOptionSelected === 1
                                ? responsables
                                : employees}
                    selectionOptions={{
                        selectorFieldName,
                        setSelectedItems,
                        timeToResetSelectedItems: timeToResetSelectedItems
                    }}
                    cardComponent={
                        tabOptionSelected === 0
                        ? {
                            cardContent: (row) => ApprovalGroupCard(
                                row, 
                                theme, 
                                setApprovalGroupoEdit, 
                                setOpenApprovalGroupsModal
                            ),
                        }
                        : {
                            imageData: {
                                descriptionRowName: "Descripcion",
                            },
                            cardContent:  tabOptionSelected === 1
                                ? (row: any) => ApprovalResponsableCard(row, handleOpenChangeRoleModal)
                                : ApprovalEmployeeCard,
                        }
                    }
                    // setOrderedData={(sortField: any, sortType: any, rowData: any) => dispatch(setPaymentSlipsSort({sortField, sortType, rowData}))}
                    loading={ responsablesLoading || loading}
                    hiddenSearchInput={true}
                    customStartItemOptionBar={() => (
                        <Button 
                            variant="outlined"
                            color="primary"
                            style={{backgroundColor: "white", marginRight: ".5rem"}}
                            startIcon={<AddOutlinedIcon />}
                            onClick={handleAddAction}
                        >
                            Agregar
                        </Button>
                    )}
                    customItemOptionBar={() => (
                        <Button 
                            variant="outlined"
                            color="error"
                            style={{backgroundColor: "#F8E6E6"}}
                            disabled={selectedItems.length === 0}
                            onClick={handleDeleteItems}
                            startIcon={<DeleteOutlinedIcon />}
                        >
                            Eliminar
                        </Button>
                    )}
                    tableOptionsBar={{
                        useDrawer: false,
                    }}
                />
            </Paper>
            <Dialog
                open={openDeleteModal}
                aria-labelledby="responsive-dialog-title"
                style={{width: "100%",}}
            >
                <DialogTitle
                    id="responsive-dialog-title" 
                    style={{padding: "0", margin: "2rem", textAlign: "center"}} 
                    variant="h5"
                >
                    ¿Seguro de eliminar los {tabOptionSelected === 0
                                ? "grupos"
                                : tabOptionSelected === 1
                                    ? "responsables"
                                    : "colaboradores"
                            } seleccionados?
                </DialogTitle>
                <DialogContent style={{width: "100%", textAlign: "center"}}>
                    <Grid container spacing="1.5rem">
                        <Grid item xs={12}>
                            se procederá a eliminar:
                        </Grid>
                    </Grid>
                    <List dense style={{ listStyleType: 'disc', padding: '0 20px' }}>
                        {selectedItemsLabel.map((item, index) => (
                            <ListItem key={index} style={{ padding: '5px 0' }}>
                                <ListItemIcon style={{minWidth: 0}}>
                                    <ArrowRightIcon />
                                </ListItemIcon>
                                <ListItemText primary={item} />
                            </ListItem>
                        ))}
                    </List>
                </DialogContent>
                <DialogActions>
                    <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                        <Grid item xs={6}>
                            <Button 
                                variant="outlined" 
                                style={{width: "8rem"}}
                                startIcon={<CloseIcon style={{height: "1rem"}} />}
                                onClick={() => setOpenDeleteModal(false)}
                            >
                                Cancelar
                            </Button>
                        </Grid>
                        <Grid item xs={6} textAlign={"right"}>
                            <Button 
                                variant="contained" 
                                color="error"
                                style={{width: "8rem"}}
                                startIcon={<CheckIcon style={{height: "1rem"}} />}
                                onClick={async () => {
                                    const reset = await handleDeleteAction();
                                    if (reset) {
                                        handleResetSelectedItems();
                                    }
                                    setOpenDeleteModal(false);
                                }}
                            >
                                Eliminar
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
            {openChangeRoleModal && <Dialog
                open={openChangeRoleModal}
                onClose={handleCloseChangeRoleModal}
                aria-labelledby="change-role-dialog-title"
            >
                <DialogTitle id="change-role-dialog-title">
                    Cambiar Rol
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body1">
                        ¿Estás seguro de cambiar el rol de <strong>{selectedResponsible?.Descripcion}</strong> de 
                        <strong> {selectedResponsible?.RoleName}</strong> a 
                        <strong> {newRoleId === 3 ? 'Colaborador' : 'Aprobador'}</strong>?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseChangeRoleModal} disabled={changingRole}>
                        Cancelar
                    </Button>
                    <Button 
                        onClick={handleConfirmChangeRole} 
                        color="primary" 
                        variant="contained"
                        disabled={changingRole}
                        startIcon={<CheckIcon />}
                    >
                        {changingRole ? 'Cambiando...' : 'Confirmar'}
                    </Button>
                </DialogActions>
            </Dialog>}
            {openApprovalGroupsModal && 
                <CreateApprovalGroupModal
                    companyId={selectedCompany} 
                    handleCloseModal={handleCloseModal}
                    approvalGroupToEdit={approvalGroupoEdit}
                />
            }
            {openEmployeesModal && <EmployeesModal 
                ruc={selectedCompany} 
                approvalGroupId={selectedApprovalGroup} 
                handleCloseModal={handleCloseModal}
                action={
                    tabOptionSelected === 2 
                        ? "addEmployees"
                        : "addResponsables"
                }
            />}
            {snackBarMessage && <MySnackbar 
                msg={snackBarMessage.msg} 
                severity={snackBarMessage.success ? 'success' : 'error'}
                onClose={() => setSnackBarMessage(undefined)}
                open={true}
            />}
        </Grid>
    );
}


export default ApprovalGroupsView;